// Stage color mapping - consistent across the app
// Returns hex colors (compatible with both web HSL and React Native)

const STAGE_COLORS: Record<string, string> = {
  main: "#ef4444", // Red
  techno: "#eab308", // Yellow
  house: "#8b5cf6", // Purple
  trance: "#3b82f6", // Blue
  hardstyle: "#22c55e", // Green
  ambient: "#14b8a6", // Teal
  chill: "#14b8a6", // Teal
};

const FALLBACK_COLORS = [
  "#f97316", // Orange
  "#a855f7", // Pink
  "#ec4899", // Rose
  "#10b981", // Emerald
];

export const getStageColor = (stageName: string): string => {
  const normalizedStage = stageName.toLowerCase();

  for (const [key, color] of Object.entries(STAGE_COLORS)) {
    if (normalizedStage.includes(key)) return color;
  }

  // Default: cycle through fallback colors based on hash
  const hash = stageName.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return FALLBACK_COLORS[hash % FALLBACK_COLORS.length];
};
